import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import 'rxjs/add/observable/throw';

import { BaseWebService } from "../shared/services/base-web.service";

@Injectable()
export class DocusignApprovalCompleteService {
    constructor(
        private _basewebservice: BaseWebService
    ) { }

    // complete docusign
    docusignComplete(data: any, selectedRole: any, defaultRole: any) {
        let id = data.id;
        return this._basewebservice.request("v1/complete-approval/" + id + "/", "get", data, selectedRole, defaultRole)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    handleError(error: Response | any) {
        return Observable.throw(error);
    }

}
